import { LogoutOutlined, MessageRounded } from "@mui/icons-material";
import {
    Avatar,
    Box,
    createTheme,
    Divider,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
    ThemeProvider,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { COOKIE_INFO, COOKIE_SESS } from "../config";
import { getChats } from "../requests/chats";
import { removeSession, setChatInfo } from "../store";

export default function Home() {
    const { enqueueSnackbar } = useSnackbar();
    const { chatId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = useSelector((state) => {
        return state.session.value ? state.session.value.token : null;
    });
    const name = useSelector((state) => {
        return state.session.value ? state.session.value.name : null;
    });
    const [, setCookie, removeCookie] = useCookies([COOKIE_SESS]);

    const [chats, setChats] = useState([]);

    const handleLogout = (e) => {
        dispatch(removeSession());
        removeCookie(COOKIE_SESS, {
            path: "/",
            sameSite: "none",
            secure: true,
        });
        removeCookie(COOKIE_INFO, {
            path: "/",
            sameSite: "none",
            secure: true,
        });
    };

    useEffect(() => {
        if (!token) {
            dispatch(removeSession());
        }
    }, [token]);

    useEffect(() => {
        if (token) {
            const load = async () => {
                const r = await getChats({ token });
                if (r.status === "error") {
                    if (r.message === "Token invalido") {
                        dispatch(removeSession());
                    } else {
                        // enqueueSnackbar(r.message, {
                        //     variant: "error",
                        // });
                    }
                } else {
                    setChats(r.result);
                }
            };

            load();
            const interval = setInterval(() => {
                load();
            }, 2000);

            return () => {
                clearInterval(interval);
            };
        }
    }, [token]);

    return (
        <Box sx={{ display: "flex" }}>
            <Drawer
                sx={{
                    width: 300,
                    flexShrink: 0,
                    "& .MuiDrawer-paper": {
                        width: 300,
                        boxSizing: "border-box",
                    },
                }}
                variant="permanent"
                anchor="left"
            >
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <Avatar
                                sx={{
                                    bgcolor: "primary.main",
                                }}
                            >
                                {name ? name.slice(0, 1).toUpperCase() : "?"}
                            </Avatar>
                        </ListItemIcon>
                        <ListItemText primary={name} />
                    </ListItem>
                    <ListItem>
                        <ListItemButton onClick={handleLogout}>
                            <ListItemIcon>
                                <LogoutOutlined color="primary" />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Cerrar sesión"}
                                primaryTypographyProps={{
                                    color: "primary",
                                }}
                            />
                        </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemText
                            primary={"Chats"}
                            primaryTypographyProps={{
                                sx: {
                                    fontWeight: "bold",
                                    variant: "caption",
                                },
                            }}
                        />
                    </ListItem>
                    {chats.map(
                        ({
                            name,
                            _id,
                            info,
                            infoLabels,
                            messages,
                            channel,
                        }) => (
                            <ListItem key={_id} disablePadding>
                                <ThemeProvider
                                    theme={createTheme({
                                        palette: {
                                            primary: {
                                                main:
                                                    channel === "web"
                                                        ? "#4caf50"
                                                        : channel ===
                                                          "messenger"
                                                        ? "#2196f3"
                                                        : "#e91e63",
                                            },
                                        },
                                    })}
                                >
                                    <ListItemButton
                                        selected={_id === chatId}
                                        color="primary"
                                        onClick={(e) => {
                                            setCookie(
                                                COOKIE_INFO,
                                                { info, infoLabels },
                                                {
                                                    path: "/",
                                                    sameSite: "none",
                                                    secure: true,
                                                }
                                            );
                                            dispatch(
                                                setChatInfo({
                                                    info,
                                                    infoLabels,
                                                })
                                            );
                                            navigate(
                                                `/home/${channel}/${_id}/${name}`
                                            );
                                        }}
                                    >
                                        <ListItemIcon color="primary">
                                            <Avatar
                                                sx={{
                                                    bgcolor:
                                                        channel === "web"
                                                            ? "#4caf50"
                                                            : channel ===
                                                              "messenger"
                                                            ? "#2196f3"
                                                            : "#e91e63",
                                                }}
                                            >
                                                {channel === "web"
                                                    ? "w"
                                                    : channel === "messenger"
                                                    ? "f"
                                                    : "i"}
                                            </Avatar>
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={name}
                                            secondary={
                                                messages &&
                                                messages[messages.length - 1]
                                                    ? messages[
                                                          messages.length - 1
                                                      ].content
                                                    : "Sin mensajes"
                                            }
                                            primaryTypographyProps={{
                                                sx: {
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                },
                                            }}
                                            secondaryTypographyProps={{
                                                sx: {
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                },
                                            }}
                                        />
                                    </ListItemButton>
                                </ThemeProvider>
                            </ListItem>
                        )
                    )}
                </List>
            </Drawer>
            <Box component={"main"} sx={{ flexGrow: 1, display: "flex" }}>
                <Outlet />
            </Box>
        </Box>
    );
}
